<template>
  <div class="partners-bar">
    <div class="title">合作伙伴</div>
    <div v-if="mapDepotList" @click.stop="scrollClick($event)">
      <vue-seamless-scroll :data="mapDepotList" :class-option="optionLeft" class="seamless-warp2"
                           :style="{'width':mapDepotList.length*2*170+'px'}">
        <ul class="item">
          <li v-for="(item,index) in mapDepotList" :key="index" >
            <template v-if="mode == 1">
              <img class="img" :src="echoImg(item.url)" alt="" :dataId="item.id" fit="fill">
            </template>
            <template v-else-if="mode == 2">
              <div class="name" :dataId="item.id">{{item.title}}</div>
            </template>
            <template v-else-if="mode == 3">
              <img class="img" :src="echoImg(item.url)" alt="" :dataId="item.id" fit="fill">
              <div class="name name2" :dataId="item.id">{{item.title}}</div>
            </template>
            <template v-else-if="mode == 4">
              <img class="img" :src="echoImg(item.url)" alt="" :dataId="item.id" fit="fill">
              <div class="name1" :dataId="item.id">{{item.title}}</div>
            </template>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>

  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: "Partners",
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      mode:3,//1表示显示图片，2表示显示名称，3表示在图片下方,4表示在图片底部
      mapDepotList:[
        {id:1,title:'图片1图片1图片1图片1图片1图片1图片1图片1图片1图片1图片1图片1',url:'1974ad48fd2349779497ae57b67147cf/WebAnnexFile/2023/01/11/20230111_2d6e82e34ed74f3cb2f9880d8134bcfa.jpg'},
        {id:2,title:'图片2',url:'1974ad48fd2349779497ae57b67147cf/WebAnnexFile/2023/04/21/20230421_4b3dfcb001924f84b19b88d06a3eef6c.jpg'},
        {id:3,title:'图片3',url:'1974ad48fd2349779497ae57b67147cf/WebAnnexFile/2023/04/21/20230421_8e1a025f0a4e49ffb358a1e56388af44.webp'},
        {id:4,title:'图片4',url:'1974ad48fd2349779497ae57b67147cf/WebAnnexFile/2023/01/11/20230111_317d73481a574fe58812dd7bb41ceab5.jpg'},
      ],
      scrollKey:0,
    }
  },
  computed: {
    optionLeft() {
      return {
        step:0.8,
        direction: 3,// 0向下 1向上 2向左 3向右
        // limitMoveNum: this.mapDepotList.length,// 开始无缝滚动的数据量 this.dataList.length
        // hoverStop: true,
        // openTouch: false,
      };
    },
  },
  created() {
    if(this.mapDepotList.length<8){
      this.mapDepotList.forEach(item=>{
        this.mapDepotList.push(item)
      })
    }
  },
  mounted() {

  },
  methods: {
    scrollClick(e){
      let id = e.target.getAttribute('dataId')
      console.log(id)
    },
  },
};
</script>
<style lang="scss" scoped>
  .partners-bar{
    width: 100%;
    overflow: hidden;
    margin-top: 30px;
    .title{
      height: 40px;
      line-height: 40px;
      background: #00A384;
      color: #fff;
      font-weight: bold;
      padding-left: 20px;
    }
    .seamless-warp2 {
      //width: 3200px;
      overflow: hidden;
      padding: 20px;
      background: #fff;
      ul.item {
        float: left;
        width: 100%;
        li {
          position: relative;
          float: left;
          cursor: pointer;
          margin-right: 20px;
          .img{
            display: inline-block;
            width: 150px;
            height: 150px;
          }
          .name{
            width: 120px;
            color: #333;
            font-weight: bold;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-top: 10px;
            padding: 0 5px;
          }
          .name1{
            position: absolute;
            left: 0;
            bottom: 0;
            background: rgba(0,0,0,.8);
            width: 130px;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #fff;
            font-weight: bold;
            padding: 5px 10px;
          }
          .name2{
            width: 150px;
          }
        }
      }
    }
  }

</style>
